import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Button
} from "reactstrap";

import {
  exportNewsletterToWord,
  exportNewsletterToPdf
} from "utils/exportNewsletter";

// Read-only "at a glance" view of a full newsletter.
// Renders every input (page 1 table portions, page 2 sections, page 3 rich
// text) on a single scrollable screen so the admin can review everything
// before saving. Reused by the create/edit wizard.
export default class NewsletterPreview extends React.Component {
  // PDF 로 캡처할 영역 (작업 버튼은 제외)
  printRef = React.createRef();

  state = {
    exporting: false
  };

  handleExportWord = () => {
    exportNewsletterToWord(
      this.props.magazine || {},
      this.props.pageNames,
      this.props.date,
      this.props.noOfWeeks
    );
  };

  handleExportPdf = async () => {
    this.setState({ exporting: true });
    try {
      await exportNewsletterToPdf(
        this.printRef.current,
        this.props.date,
        this.props.noOfWeeks
      );
    } catch (err) {
      console.error(err);
      alert("PDF 생성 중 오류가 발생했습니다. 다시 시도해 주세요.");
    }
    this.setState({ exporting: false });
  };

  rawMarkup(param) {
    return { __html: param || "" };
  }

  formatDate(date) {
    if (!date) {
      return "";
    }
    var parsed = Date.parse(date);
    if (isNaN(parsed)) {
      return date;
    }
    return new Date(parsed).toUTCString().split("00:00")[0];
  }

  render() {
    var magazine = this.props.magazine || {};
    var page1 = magazine.page1 || {};
    var page2 = magazine.page2 || [];
    var page3 = magazine.page3 || {};
    var pageNames = this.props.pageNames || ["", "", ""];

    var tableArray = page1.tableArray || [];

    return (
      <div className="content">
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h5" style={{ marginBottom: 0 }}>
                한눈에 보기 — 뉴스레터 미리보기
              </CardTitle>
              <p className="card-category">
                {this.formatDate(this.props.date)}
                {this.props.noOfWeeks ? " · " + this.props.noOfWeeks + "주차" : ""}
              </p>
            </CardHeader>
            <CardBody>
              <div ref={this.printRef} style={{ backgroundColor: "#fff" }}>
              {/* ************ PAGE 1 ************ */}
              <Row>
                <Col md="12">
                  <h5 style={styles.sectionTitle}>
                    <span style={styles.badge}>1</span>
                    {pageNames[0] || "페이지 1"}
                  </h5>
                  <div style={styles.page1Head}>
                    {page1.image ? (
                      <img src={page1.image} alt="" style={styles.image} />
                    ) : (
                      <div style={styles.imagePlaceholder}>이미지 없음</div>
                    )}
                    <h5 style={{ padding: 10, margin: 0 }}>
                      {page1.imageText || (
                        <span style={styles.empty}>(이미지 설명 없음)</span>
                      )}
                    </h5>
                  </div>

                  {tableArray.length === 0 ? (
                    <p style={styles.empty}>(입력된 표 항목이 없습니다)</p>
                  ) : (
                    tableArray.map((table, index) => {
                      return (
                        <Table key={index} bordered style={{ marginTop: 15 }}>
                          <thead>
                            <tr>
                              <th colSpan={2}>
                                {table.header || (
                                  <span style={styles.empty}>(제목 없음)</span>
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(table.rows || []).map((row, rowIndex) => {
                              return (
                                <tr key={rowIndex}>
                                  <td style={{ width: "30%" }}>{row.column1}</td>
                                  <td style={{ width: "70%" }}>{row.column2}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      );
                    })
                  )}
                </Col>
              </Row>

              <hr />

              {/* ************ PAGE 2 ************ */}
              <Row>
                <Col md="12">
                  <h5 style={styles.sectionTitle}>
                    <span style={styles.badge}>2</span>
                    {pageNames[1] || "페이지 2"}
                  </h5>
                  {page2.length === 0 ? (
                    <p style={styles.empty}>(입력된 항목이 없습니다)</p>
                  ) : (
                    page2.map((section, index) => {
                      return (
                        <Table key={index} bordered style={{ marginTop: 15 }}>
                          <thead>
                            <tr>
                              <th>
                                {section.header || (
                                  <span style={styles.empty}>(제목 없음)</span>
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ whiteSpace: "pre-wrap" }}>
                                {section.text}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    })
                  )}
                </Col>
              </Row>

              <hr />

              {/* ************ PAGE 3 ************ */}
              <Row>
                <Col md="12">
                  <h5 style={styles.sectionTitle}>
                    <span style={styles.badge}>3</span>
                    {pageNames[2] || "페이지 3"}
                  </h5>
                  <Table bordered style={{ marginTop: 15 }}>
                    <thead>
                      <tr>
                        <th>
                          {page3.header || (
                            <span style={styles.empty}>(제목 없음)</span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div
                            dangerouslySetInnerHTML={this.rawMarkup(page3.text)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
              </div>

              {/* ************ EXPORT ************ */}
              <Row>
                <Col md="12">
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      flexWrap: "wrap",
                      marginBottom: 15
                    }}
                  >
                    <button
                      type="button"
                      className="inline-flex items-center gap-2 rounded-xl bg-sky-500 px-5 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600"
                      onClick={this.handleExportWord}
                    >
                      📄 Word로 내보내기
                    </button>
                    <button
                      type="button"
                      disabled={this.state.exporting}
                      className="inline-flex items-center gap-2 rounded-xl bg-rose-500 px-5 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-rose-600 disabled:cursor-not-allowed disabled:opacity-60"
                      onClick={this.handleExportPdf}
                    >
                      {this.state.exporting ? "⏳ 생성 중…" : "🖨️ PDF로 내보내기"}
                    </button>
                  </div>
                </Col>
              </Row>

              {/* ************ ACTIONS ************ */}
              <Row>
                <Col md="12">
                  {this.props.onBack && (
                    <Button
                      className="btn-round"
                      color="default"
                      onClick={() => {
                        this.props.onBack();
                      }}
                    >
                      이전 (편집으로)
                    </Button>
                  )}
                  {this.props.onSave && (
                    <Button
                      className="btn-round"
                      style={{ float: "right" }}
                      color="primary"
                      onClick={() => {
                        this.props.onSave();
                      }}
                    >
                      {this.props.edit ? "저장" : "생성하기"}
                    </Button>
                  )}
                  {this.props.onClose && (
                    <Button
                      className="btn-round"
                      color="default"
                      onClick={() => {
                        this.props.onClose();
                      }}
                    >
                      닫기
                    </Button>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </div>
    );
  }
}

const styles = {
  sectionTitle: {
    fontWeight: 600,
    borderBottom: "2px solid #51cbce",
    paddingBottom: 6,
    marginTop: 10
  },
  badge: {
    display: "inline-block",
    width: 24,
    height: 24,
    lineHeight: "24px",
    textAlign: "center",
    borderRadius: "50%",
    backgroundColor: "#51cbce",
    color: "white",
    fontSize: 13,
    marginRight: 10
  },
  page1Head: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: 10
  },
  image: {
    maxWidth: 220,
    maxHeight: 220,
    objectFit: "cover",
    borderRadius: 6
  },
  imagePlaceholder: {
    width: 160,
    height: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f3f3f3",
    color: "#999",
    borderRadius: 6
  },
  empty: {
    color: "#bbb",
    fontStyle: "italic"
  }
};
